import RateCodeList from './RateCodeList';

export default RateCodeList;